import type {
  DiscoverClientSource,
  DiscoverEvidenceBlock,
  DiscoverNoteSource,
} from "../shared/source-contract";
import { GenericEvidenceCard } from "./generic-evidence-card";
import { TwitterNoteSourceCard } from "./twitter-note-source-card";

export const twitterClientSource = {
  id: "twitter-lists",
  matches({
    sourceType,
  }: {
    sourceType: string;
    sourceId: string;
    metadata: Record<string, unknown>;
  }) {
    return sourceType.toUpperCase() === "TWITTER";
  },
  renderEvidence({
    block,
    key,
  }: {
    block: DiscoverEvidenceBlock;
    key: string;
  }) {
    return <GenericEvidenceCard block={block} key={key} />;
  },
  renderNoteSource({
    note,
  }: {
    exploreBase: string;
    note: DiscoverNoteSource;
    onOpenChange: (open: boolean) => void;
  }) {
    return <TwitterNoteSourceCard sourceId={note.sourceId} />;
  },
} satisfies DiscoverClientSource;
